export default "__VITE_ASSET__D7EipCa0__"